import { selectActiveCall, selectActiveCallId, selectAnyError, selectCanAcceptCall, selectCanCreateCall, selectCanEndCall, selectCanRejectCall, selectHasRemoteMedia, selectIsInCall, selectIsLocalAudioEnabled, selectIsLocalMediaAcquiring, selectIsLocalMediaReady, selectIsLocalVideoEnabled, selectIsNegotiating, selectIsSignalingConnected, selectIsSignalingReady, selectShouldShowIncomingRinging, selectShouldShowOutgoingRinging, selectShouldShowReconnectBanner } from '../call-prototype/domain/selectors.js';

export const getCallStatusLabel = (state) => {
    if (!state) return 'idle';

    if (selectShouldShowReconnectBanner(state)) return 'reconnecting';
    if (selectShouldShowIncomingRinging(state)) return 'incoming-ringing';
    if (selectShouldShowOutgoingRinging(state)) return 'outgoing-ringing';
    if (selectIsNegotiating(state)) return 'negotiating';
    if (selectIsInCall(state)) return 'in-call';
    if (selectIsLocalMediaAcquiring(state)) return 'acquiring-media';
    if (selectIsSignalingReady(state)) return 'ready';
    if (selectIsSignalingConnected(state)) return 'connected';

    return 'idle';
};

export const mapControllerStateToCallUi = (state) => {
    if (!state) {
        return {
            status: 'idle',
            hasError: false
        };
    }

    const activeCall = selectActiveCall(state);
    const errorMessage =
        state.error?.message ||
        state.media?.error?.message ||
        state.rtc?.error?.message ||
        null;

    return {
        status: getCallStatusLabel(state),
        signalingConnectionState: state.signalingConnectionState,
        rtcConnectionState: state.rtc?.connectionState,
        callState: activeCall?.serverCallState || null,
        activeCallId: selectActiveCallId(state),
        remoteUserId: activeCall?.remoteUserId || null,
        canCreateCall: selectCanCreateCall(state),
        canAcceptCall: selectCanAcceptCall(state),
        canRejectCall: selectCanRejectCall(state),
        canEndCall: selectCanEndCall(state),
        isInCall: selectIsInCall(state),
        isNegotiating: selectIsNegotiating(state),
        isReconnecting: selectShouldShowReconnectBanner(state),
        isIncomingRinging: selectShouldShowIncomingRinging(state),
        isOutgoingRinging: selectShouldShowOutgoingRinging(state),
        isLocalMediaAcquiring: selectIsLocalMediaAcquiring(state),
        isLocalMediaReady: selectIsLocalMediaReady(state),
        isLocalAudioEnabled: selectIsLocalAudioEnabled(state),
        isLocalVideoEnabled: selectIsLocalVideoEnabled(state),
        hasRemoteMedia: selectHasRemoteMedia(state),
        hasError: selectAnyError(state),
        errorMessage
    };
};

